import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import minr from '@weareumi/minr';
import seo from './plugins/seo';
import appInsights from './plugins/appInsights';

import '@weareumi/minr/minr.css';
import './assets/scss/index.scss';

const app = createApp(App);

app.use(store).use(router).use(minr).use(seo, { separator: '|', compliment: 'Efficiency Grant' }).mount('#app');

if (process.env.NODE_ENV === 'production') {
  app.use(appInsights, { instrumentationKey: '5e7868dd-5b0b-4cd9-bd11-5fa16834d949', excludeRequestFromAutoTrackingPatterns: ['api/notifications'] });
}

app.config.globalProperties.$filters = {
    userFriendlyDate (value) {
      return new Date(value).toLocaleDateString('en-GB');
    }
};
